
  export default function* labSaga() {
  }